import { css } from "goober";
import { t } from "i18next";

import { shardInfo } from "@/game-lol/constants/constants.mjs";
import Static from "@/game-lol/utils/static.mjs";
import { getStaticData, getWinRateColor } from "@/game-lol/utils/util.mjs";
import { getLocale } from "@/util/i18n-helper.mjs";

const cssRuneTooltip = () => css`
  display: flex;
  align-items: flex-start;
  gap: var(--sp-3);
  padding: var(--sp-3);

  .meta {
    display: grid;
    gap: var(--sp-3);
  }
  .description,
  rules,
  li {
    font-weight: 600;
    font-size: var(--sp-3e);
    letter-spacing: -0.009em;
    color: var(--shade1);
    list-style: none;
  }
  li {
    padding-left: var(--sp-2);
    margin: var(--sp-1) 0;
  }
  hr {
    display: block;
    width: 100%;
    height: 1px;
    background: var(--shade7);
    margin-block: var(--sp-4);
  }

  speed,
  scaleAP {
    font-weight: 600;
    color: var(--shade1);
  }

  .stats {
    display: flex;
    align-items: center;
    gap: var(--sp-4);
    background: var(--shade8);
    padding: var(--sp-2) var(--sp-3);
    color: var(--shade1);
    border-radius: var(--br-sm);
  }
`;

export default function getRuneTooltip(
  runeId,
  runeStats,
  buildGames,
  isProBuild,
) {
  const runesDetails = getStaticData("runeDetails");
  const isShard = shardInfo[runeId];
  const runeInfo = isShard ? isShard : runesDetails?.[runeId];

  if (!runeId) return null;

  const winrate =
    runeStats && runeStats.games ? (runeStats.wins / runeStats.games) * 100 : 0;
  const pickrate = runeStats && buildGames ? runeStats.games / buildGames : 0;

  const stats = runeStats?.games
    ? /* html */ `
    <div class="stats type-caption--bold">
      <span style="color: ${getWinRateColor(winrate)}">
        ${t("lol:percentWinrate", "{{winrate}}% Win Rate", {
          winrate: winrate.toLocaleString(getLocale(), {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
          }),
        })}
      </span>
      <span>
        ${pickrate.toLocaleString(getLocale(), {
          style: "percent",
          minimumFractionDigits: 1,
          maximumFractionDigits: 1,
        })}
        ${t("lol:pickRate", "Pick Rate")}
        (${runeStats.games.toLocaleString(getLocale())})
      </span>
    </div>
  `
    : /* html */ `
    <div class="stats type-caption--bold">
      <span>
        ${t("lol:noRuneStats", "No stats for this rune (low pick rate)")}
      </span>
    </div>
    `;

  const description = isShard
    ? t(runeInfo?.desc)
    : runeInfo
      ? runeInfo.desc.replace(/<hr>/g, "<br /><br />")
      : "";

  return /* html */ `
    <div class="${cssRuneTooltip()}">
      <img src="${Static.getRuneImage(runeId)}" width="40" height="40" />
      <div class="meta">
        <p class="type-article-headline">
          ${isShard ? t(runeInfo?.name) : runeInfo?.name || ""}
        </p>
        <p class="description">
          ${description}
        </p>
        ${!isProBuild ? stats : ""}
      </div>
    </div>
  `;
}
